module.exports = __webpack_public_path__ + "img/picture_VIP01.332bc467.png";